import React from "react";
import { Text, FrameIcon } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { config } from "../../../config/config";
import { getAppState } from "../../../state";
import { ListInfoStyled, Spacer } from "../styles/Styled";
import { ProfileWrapper } from "../../Settings/styles/Styled";

const BuildInfo = () => {
  // This build info is a placeholder that gets updated in Jenkins once the app is built. This means locally the version
  // won't be displayed in the screen but only when the app is being served from a given environment (prod, stg, dev...)
  const buildInfo = getAppState().buildInfo;
  buildInfo.publicVersion = config.get().sdk.publicVersion;
  return (
    buildInfo && (
      <ListInfoStyled data={buildInfo} size="xsmall" color="white" type="dl" display="inline" separator=":" />
    )
  );
};

export const Help = () => {
  return (
    <>
    <ProfileWrapper>
      <FrameIcon name="help" />
      <Text rank="1" text={i18n.get(`pages.settings.help.title`)} size="xmedium" />
    </ProfileWrapper>
    <Spacer />
    <Text text={i18n.get(`pages.settings.help.paragraph1`)} />
    <Text rank={1} size="default" text={i18n.get(`pages.settings.help.paragraph2`)} />
    <BuildInfo />
    </>
  );
};